export default "__VITE_ASSET__DhcM8Mp8__"